import { getURLParams } from '@src/utils/fp';

export const getQueryParams = () => {
  try {
    const params = window.location.hash.split('/');
    const zohoParams = params[params.length - 1];
    return zohoParams === ''
      ? getURLParams()
      : Object.fromEntries(new URLSearchParams(zohoParams));
  } catch (e) {
    return null;
  }
};
